import { ControlCodes } from '@bcube/shared/constants';
import {
  BadgeCheck,
  // CircuitBoard, FileCheck, Terminal e Wrench só eram usados pelos itens de
  // "Ferramentas"/"Perfis de Configuração", agora comentados abaixo. Mantidos
  // comentados junto para que descomentar os itens volte a compilar direto.
  // CircuitBoard,
  Download,
  Factory,
  // FileCheck,
  HardDrive,
  ScrollText,
  Settings,
  // Terminal,
  TestTube,
  // Wrench,
} from 'lucide-react';
import type { ModuleConfig } from './types';

export const productionModule: ModuleConfig = {
  id: 'production',
  title: 'Módulo Produção',
  description: 'Gestão de ordens de produção e processos de fabricação.',
  basePath: '/production',
  icon: Factory,
  navigation: [
    {
      name: 'Dispositivos',
      pathname: '/production/devices',
      icon: <HardDrive size={16} className="text-muted-foreground" />,
      code: ControlCodes.production_device,
    },
    // Ocultados do menu: substituídos pelo "Configurador sso" (MFE embutido).
    // Mantidos comentados para reversão rápida. Ver config/modules/index.tsx.
    // {
    //   name: 'Perfis de Configuração',
    //   pathname: '/production/config-profiles',
    //   icon: <Settings size={16} className="text-muted-foreground" />,
    //   code: ControlCodes.production_configuration_profile,
    // },
    // {
    //   name: 'Ferramentas',
    //   pathname: '/production/tools',
    //   icon: <Wrench size={16} className="text-muted-foreground" />,
    //   code: ControlCodes.production_tool,
    //   children: [
    //     {
    //       name: 'Auto Teste',
    //       pathname: '/production/tools/auto-test',
    //       icon: <TestTube size={16} className="text-muted-foreground" />,
    //       code: ControlCodes.production_tool,
    //     },
    //     {
    //       name: 'Configurador',
    //       pathname: '/production/tools/configurator',
    //       icon: <Settings size={16} className="text-muted-foreground" />,
    //       code: ControlCodes.production_tool,
    //     },
    //     {
    //       name: 'Gravação de Firmware',
    //       pathname: '/production/tools/firmware-update',
    //       icon: <Download size={16} className="text-muted-foreground" />,
    //       code: ControlCodes.production_tool,
    //     },
    //     {
    //       name: 'Identificador',
    //       pathname: '/production/tools/identificator',
    //       icon: <CircuitBoard size={16} className="text-muted-foreground" />,
    //       code: ControlCodes.production_tool,
    //     },
    //     {
    //       name: 'Check de Configuração',
    //       pathname: '/production/tools/check-configuration',
    //       icon: <FileCheck size={16} className="text-muted-foreground" />,
    //       code: ControlCodes.production_tool,
    //     },
    //     {
    //       name: 'Terminal Serial',
    //       pathname: '/production/tools/commands',
    //       icon: <Terminal size={16} className="text-muted-foreground" />,
    //       code: ControlCodes.production_tool,
    //     },
    //   ],
    // },
    {
      name: 'Logs',
      pathname: '/production/logs',
      icon: <ScrollText size={16} className="text-muted-foreground" />,
      code: ControlCodes.production_logs,
      children: [
        {
          name: 'Auto Teste',
          pathname: '/production/logs/auto-test',
          icon: <TestTube size={16} className="text-muted-foreground" />,
          code: ControlCodes.production_logs,
        },
        {
          name: 'Configuração',
          pathname: '/production/logs/configurator',
          icon: <Settings size={16} className="text-muted-foreground" />,
          code: ControlCodes.production_logs,
        },
        {
          name: 'Gravação de Firmware',
          pathname: '/production/logs/firmware-update',
          icon: <Download size={16} className="text-muted-foreground" />,
          code: ControlCodes.production_logs,
        },
        {
          name: 'Identificação',
          pathname: '/production/logs/identificator',
          icon: <BadgeCheck size={16} className="text-muted-foreground" />,
          code: ControlCodes.production_logs,
        },
      ],
    },
  ],
  landingActions: [
    {
      title: 'Dispositivos',
      href: '/production/devices',
      code: ControlCodes.production_device,
      icon: HardDrive,
      iconForeground: 'text-purple-700',
      iconBackground: 'bg-purple-50',
      description: 'Gerencie dispositivos IoT registrados, seriais e modelos de equipamentos.',
    },
    // Ocultados da landing: substituídos pelo "Configurador sso" (MFE embutido).
    // {
    //   title: 'Perfis de Configuração',
    //   href: '/production/config-profiles',
    //   code: ControlCodes.production_configuration_profile,
    //   icon: Settings,
    //   iconForeground: 'text-green-700',
    //   iconBackground: 'bg-green-50',
    //   description:
    //     'Gerencie perfis de configuração para equipamentos IoT de diferentes tecnologias.',
    // },
    // {
    //   title: 'Ferramentas',
    //   href: '/production/tools',
    //   code: ControlCodes.production_tool,
    //   icon: Wrench,
    //   iconForeground: 'text-blue-700',
    //   iconBackground: 'bg-blue-50',
    //   description:
    //     'Execute operações de produção: auto teste, configuração, gravação de firmware, identificação e verificação.',
    // },
    {
      title: 'Logs',
      href: '/production/logs',
      code: ControlCodes.production_logs,
      icon: ScrollText,
      iconForeground: 'text-slate-700',
      iconBackground: 'bg-slate-50',
      description:
        'Visualize logs de processos de produção: auto teste, configuração, firmware e identificação.',
    },
  ],
};
